let lastYear = '';
const convertMonth = (monthNumber: string) => {
  switch (monthNumber) {
    case '01':
      return 'Jan';
    case '02':
      return 'Feb';
    case '03':
      return 'Mar';
    case '04':
      return 'Apr';
    case '05':
      return 'May';
    case '06':
      return 'Jun';
    case '07':
      return 'Jul';
    case '08':
      return 'Aug';
    case '09':
      return 'Sep';
    case '10':
      return 'Oct';
    case '11':
      return 'Nov';
    case '12':
      return 'Dec';
    default:
      return '';
  }
};

export const dateConverter = (date: string) => {
  if (!date) return '';
  const dateSplited = date.split('/');
  const monthNumber = dateSplited[1];
  const yearFull = dateSplited[2];
  const yearShort = yearFull.slice(2, 4);
  const monthString = convertMonth(monthNumber);

  if (lastYear !== yearShort) {
    lastYear = yearShort;
    return `${monthString}'${yearShort}`;
  }
  return `${monthString}`;
};
